import React from 'react'
import { Box } from '@achieve/ascend'
import { Typography } from 'components/Contentful'
import classNames from 'classnames'

export const GraphicCardList = ({ content }) => {
  const title = content?.jsonContent?.jsonConfig?.title
  const list = content?.jsonContent?.jsonConfig?.list

  const getTable = () => {
    return list?.map((element, index) => (
      <Box
        className={
          'flex flex-row justify-between px-4 py-[4.8px] data-[marker="true"]:text-blue-400 data-[marker="true"]:bg-blue-50'
        }
        data-marker={element.marker}
        key={`item-subtable-${index}`}
      >
        <Box>
          <Typography
            content={element.description}
            variant="bodySm"
            fontWeight={element.marker ? 'medium' : 'regular'}
          />
        </Box>
        <Box className={'text-right'}>
          <Typography content={element.value} variant="bodySm" fontWeight="bold" />
        </Box>
      </Box>
    ))
  }

  return (
    <Box
      className={classNames(
        content?.classNameContainer,
        'shadow-[0_8.3px_67.1px_-4.1px_#00000021] rounded-[5px] bg-white'
      )}
    >
      <Box className={'border-b-neutral-75 p-4 border-b border-solid border-x-0 border-t-0'}>
        <Typography content={title} variant="bodyLg" fontWeight="medium" />
      </Box>
      <Box className={'flex flex-col px-0 py-4'}>{getTable()}</Box>
    </Box>
  )
}

export default GraphicCardList
